import { Box, Button, Select, Text, TextInput } from "@mantine/core";
import { rolesList } from "../../../Clients/Views/utils";
import { useTranslation } from "react-i18next";
import { useStyles } from "./styles";
import { useNavigate } from "react-router-dom";
import { useViewportSize } from "@mantine/hooks";
import { ThemeMode } from "../../../../Enums/themeMode";

type ISettingsForm = {
  isSubmitting: boolean;
  form: any;
};

const SettingsForm = ({ isSubmitting, form }: ISettingsForm) => {
  const { classes } = useStyles();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { width } = useViewportSize();
  const inputWidth = width > 700 ? 530 : 295;

  return (
    <>
      <Box className={classes.boxItemsContainer}>
        <TextInput
          label={t("nameLabel")}
          disabled={isSubmitting}
          {...form.getInputProps("firstName")}
          size="sm"
          inputWrapperOrder={["label", "input", "description", "error"]}
          styles={(theme) => ({
            label: {
              color:
                theme.colorScheme === ThemeMode.DARK
                  ? theme.colors.dark[1]
                  : theme.colors.light[1],
            },
            input: {
              width: inputWidth,
              border: isSubmitting
                ? `0.5px solid ${theme.colors.dark[4]}`
                : theme.colorScheme === ThemeMode.DARK
                ? `1px solid ${theme.colors.dark[3]}`
                : "0.5px solid",
              backgroundColor:
                theme.colorScheme === ThemeMode.DARK
                  ? "transparent"
                  : theme.colors.light[0],
              marginRight: "2rem",
              "&:focus-within": {
                borderColor: theme.colors.green[7],
              },
              color: isSubmitting
                ? "#000!important"
                : theme.colorScheme === ThemeMode.DARK
                ? theme.colors.dark[1]
                : theme.colors.light[1],
            },
          })}
        />
        <TextInput
          label={t("lastnameLabel")}
          disabled={isSubmitting}
          {...form.getInputProps("lastName")}
          size="sm"
          inputWrapperOrder={["label", "input", "description", "error"]}
          styles={(theme) => ({
            label: {
              color:
                theme.colorScheme === ThemeMode.DARK
                  ? theme.colors.dark[1]
                  : theme.colors.light[1],
            },
            input: {
              width: inputWidth,
              border: isSubmitting
                ? `0.5px solid ${theme.colors.dark[4]}`
                : theme.colorScheme === ThemeMode.DARK
                ? `1px solid ${theme.colors.dark[3]}`
                : "0.5px solid",
              backgroundColor:
                theme.colorScheme === ThemeMode.DARK
                  ? "transparent"
                  : theme.colors.light[0],
              marginRight: "2rem",
              "&:focus-within": {
                borderColor: theme.colors.green[7],
              },
              color: isSubmitting
                ? "#000!important"
                : theme.colorScheme === ThemeMode.DARK
                ? theme.colors.dark[1]
                : theme.colors.light[1],
            },
          })}
        />
      </Box>
      <Box className={classes.boxItemsContainer}>
        <TextInput
          label={t("phoneLabel")}
          disabled={isSubmitting}
          {...form.getInputProps("phone")}
          size="sm"
          inputWrapperOrder={["label", "input", "description", "error"]}
          styles={(theme) => ({
            label: {
              color:
                theme.colorScheme === ThemeMode.DARK
                  ? theme.colors.dark[1]
                  : theme.colors.light[1],
            },
            input: {
              width: inputWidth,
              border: isSubmitting
                ? `0.5px solid ${theme.colors.dark[4]}`
                : theme.colorScheme === ThemeMode.DARK
                ? `1px solid ${theme.colors.dark[3]}`
                : "0.5px solid",
              backgroundColor:
                theme.colorScheme === ThemeMode.DARK
                  ? "transparent"
                  : theme.colors.light[0],
              marginRight: "2rem",
              "&:focus-within": {
                borderColor: theme.colors.green[7],
              },
              color: isSubmitting
                ? "#000!important"
                : theme.colorScheme === ThemeMode.DARK
                ? theme.colors.dark[1]
                : theme.colors.light[1],
            },
          })}
        />
        <TextInput
          label={t("emailLabel")}
          disabled={isSubmitting}
          {...form.getInputProps("email")}
          size="sm"
          inputWrapperOrder={["label", "input", "description", "error"]}
          styles={(theme) => ({
            label: {
              color:
                theme.colorScheme === ThemeMode.DARK
                  ? theme.colors.dark[1]
                  : theme.colors.light[1],
            },
            input: {
              width: inputWidth,
              border: isSubmitting
                ? `0.5px solid ${theme.colors.dark[4]}`
                : theme.colorScheme === ThemeMode.DARK
                ? `1px solid ${theme.colors.dark[3]}`
                : "0.5px solid",
              backgroundColor:
                theme.colorScheme === ThemeMode.DARK
                  ? "transparent"
                  : theme.colors.light[0],
              marginRight: "2rem",
              "&:focus-within": {
                borderColor: theme.colors.green[7],
              },
              color: isSubmitting
                ? "#000!important"
                : theme.colorScheme === ThemeMode.DARK
                ? theme.colors.dark[1]
                : theme.colors.light[1],
            },
          })}
        />
      </Box>
      <Box className={classes.boxItemsContainer}>
        <TextInput
          label={t("position")}
          disabled={isSubmitting}
          {...form.getInputProps("position")}
          size="sm"
          inputWrapperOrder={["label", "input", "description", "error"]}
          styles={(theme) => ({
            label: {
              color:
                theme.colorScheme === ThemeMode.DARK
                  ? theme.colors.dark[1]
                  : theme.colors.light[1],
            },
            input: {
              width: inputWidth,
              border: isSubmitting
                ? `0.5px solid ${theme.colors.dark[4]}`
                : theme.colorScheme === ThemeMode.DARK
                ? `1px solid ${theme.colors.dark[3]}`
                : "0.5px solid",
              backgroundColor:
                theme.colorScheme === ThemeMode.DARK
                  ? "transparent"
                  : theme.colors.light[0],
              marginRight: "2rem",
              "&:focus-within": {
                borderColor: theme.colors.green[7],
              },
              color: isSubmitting
                ? "#000!important"
                : theme.colorScheme === ThemeMode.DARK
                ? theme.colors.dark[1]
                : theme.colors.light[1],
            },
          })}
        />
        <Box
          style={{
            width: inputWidth,
          }}
          className={classes.boxSelectContainer}
        >
          <Select
            data={rolesList}
            disabled
            label={"Rol"}
            required
            {...form.getInputProps("rol")}
            styles={(theme) => ({
              label: {
                color:
                  theme.colorScheme === ThemeMode.DARK
                    ? theme.colors.dark[1]
                    : theme.colors.light[1],
              },
              input: {
                width: inputWidth,
                color:
                  theme.colorScheme === ThemeMode.DARK
                    ? theme.colors.dark[1]
                    : "#000",
                border: `0.5px solid ${
                  theme.colorScheme === ThemeMode.DARK
                    ? theme.colors.dark[4]
                    : theme.colors.dark[4]
                }`,
                backgroundColor:
                  theme.colorScheme === ThemeMode.DARK
                    ? "transparent"
                    : theme.colors.light[0],
                "&:focus-within": {
                  borderColor: theme.colors.green[7],
                },
              },
            })}
          />
        </Box>
      </Box>
      <Box className={classes.buttonsContainer}>
        <Button
          disabled={isSubmitting}
          className={classes.buttonSave}
          type={"submit"}
        >
          <Text>{isSubmitting ? t("loading") : t("save")}</Text>
        </Button>
        <Button
          variant="outline"
          className={classes.buttonCancel}
          onClick={() => navigate(-1)}
          disabled={isSubmitting}
        >
          <Text>{t("cancelOption")}</Text>
        </Button>
      </Box>
    </>
  );
};

export default SettingsForm;
